import { render, staticRenderFns } from "./houseYangtze.vue?vue&type=template&id=6eb4519c&"
import script from "./houseYangtze.vue?vue&type=script&lang=js&"
export * from "./houseYangtze.vue?vue&type=script&lang=js&"
import style0 from "./houseYangtze.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports